import { ChangeDetectorRef } from '@angular/core';
import { AfterViewInit, Component, DoCheck, OnInit, ViewChild } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { Clientes } from '../cliente';
import { Compradetalle } from '../compradetalle';
import { Compras } from '../compras';
import { ComprasService } from '../compras.service';
import { ProveedorService } from '../proveedor.service';
import { UnidadService } from '../unidad.service';
import { Unidades } from '../unidades';

@Component({
  selector: 'app-vercompras',
  templateUrl: './vercompras.component.html',
  styleUrls: ['./vercompras.component.scss']
})
export class VercomprasComponent implements OnInit, AfterViewInit,DoCheck {
  id: string;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  compras: Compras;
  cliente: Clientes= new Clientes();
  unidad: Unidades= new Unidades();
  unidadLis: Unidades[] = [];
  compraDetalle: Compradetalle[] = [];
  listaCompras: Compras[] = [];
  urlSafe: SafeResourceUrl;
  constructor(private apiCompras:ComprasService, private apiUnidad: UnidadService,private apiClie: ProveedorService,private cdRef: ChangeDetectorRef,private alertService: AlertService, private api: ComprasService, private route: ActivatedRoute, private ruter: Router) { }
  ngDoCheck(): void {

  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    console.log(this.id);

    this.listarUnidadesVenta();


    this.api.listaCompra(this.id)
      .subscribe((
        data: Compras[]) => {

        this.compras = data[0];

        this.api.listaCompraDet(this.id)
          .subscribe((  
            data1: Compradetalle[]) => {

            this.compras.det= data1;
            this.compraDetalle = data1;   
            this.mdbTable.setDataSource(  this.compraDetalle );
              this.buscarCedula(this.compras.idCliente.toString());

          },
            err => this.alertService.danger('Error no hay  conexion..')
          );

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  }




ngAfterViewInit() {
  this.cdRef.detectChanges();
}



  regresar() {
    this.ruter.navigate(['compras']);
  }


  buscarCedula(ruc:string) {
    this.apiClie
      .getCliente(
        ruc
      )
      .subscribe(
        (data: Clientes[]) => {
          data.forEach((item) => {
            this.cliente = item;

            if (this.cliente == null) {
              this.alertService.danger("No existe la cédula o Ruc");
              this.cliente.numeroidentificacion = null;
            }
          });
        },
        (err) => {
          this.alertService.danger("Problemas con la conexión");
        }
      );
  }

  listarUnidadesVenta()
  {
  
    this.apiUnidad.getUnidadesVenta(localStorage.getItem('id')).subscribe((
      data: Unidades[]) => {
      this.unidadLis = data;
      console.log(this.unidadLis);
      
    }
      , err => {
        console.log(err);
        
      });
  
  }

  buscarUnidades(unidad:string) {
    this.apiUnidad
      .getUnidad(
        unidad
      )
      .subscribe(
        (data: Unidades[]) => {
          data.forEach((item) => {
            this.unidad = item;
              
           
          });
        },
        (err) => {
          this.alertService.danger("Problemas con la conexión");
        }
      );
  }


  
  anularDocumento() {
    if(confirm("Está seguro de anular el documento")) {
    this.compras.estado='Anualdo';
    this.listaCompras[0] = this.compras;
    this.api.compras(this.listaCompras).subscribe(
      (data) => {
        this.listaCompras=[];
        this.compras.id = 0;
        this.compras.tipoDoc='E'
        this.compras.estado='Anualdo';
        this.compras.det.forEach(entidad => {
          entidad.id=0;
        });
        this.listaCompras[0] = this.compras;
        
        this.apiCompras.anularCompras(this.listaCompras).subscribe(
          (data) => {
          
             
            this.alertService.danger('Se anulo el comprobante..');
            this.ruter.navigate(['compras']);
          
          },
          (error) => {
            this.alertService.danger(error);
          }
        );
    
      
      },
      (error) => {
        this.alertService.danger(error);
      }
    );
     
  }
    }
    anularegreso()
    {
      if(confirm("Está seguro de anular la compra")) {
        if(confirm("Se genera un nuevo egreso por devoluciòn.....")) {
          if ((this.compras.tipoDoc=='I' ||this.compras.tipoDoc=='S')  && this.compras.estado ===null){
            this.anularDocumento();
          }else{
            this.alertService.danger('No se puede anular');
            this.ruter.navigate(['compras']);
          }
      }
    }
  }

}
